export default __webpack_public_path__ + "static/ios-application-developmen-company-peerbits-dedd868664daffc373f5bc32bffb293d.png";